import React from 'react';

const images = [
  {
    image: '/assets/images/img_one.jpeg',
    heading: 'Currency accounts in your business name',
    text: "Blockchain Capitalizer, we can certainly set up your currency accounts in your business name. It's all about making your investment journey personalized and efficient.",
  },
  {
    image: '/assets/images/img_two.jpeg',
    text: "With Blockchain Capitalizer, you can hold balances in multiple cryptocurrencies. It's all about giving you the flexibility to diversify your portfolio.",
    heading: 'Hold multi currency balances',
  },
  {
    image: '/assets/images/img_three.jpeg',
    heading: 'Convert over 60 currencies, 24/7',
    text: "You can convert over 60 currencies, anytime, any day. We're all about providing you with 24/7 financial freedom.",
  },
  {
    image: '/assets/images/img_four.jpeg',
    heading: 'Secure transfers',
    text: 'We prioritize your security. All transfers are encrypted and secure, giving you peace of mind with each transaction.',
  },
];

const Features = () => {
  return (
    <div className="mb-10 grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
      {images.map((item) => (
        <div key={item.heading}>
          <img
            src={item.image}
            alt="image_"
            className="h-[200px] w-full rounded-lg"
          />
          <h4 className="my-5 text-xl font-semibold">{item.heading}</h4>
          <p className="mt-3">{item.text}</p>
        </div>
      ))}
    </div>
  );
};

export default Features;
